import { jsx as e, jsxs as r } from "@emotion/react/jsx-runtime";
import { useRef as h } from "react";
import { useKeyboardEvents as g } from "@partoohub/hooks";
import { Stack as i, Text as d, Icon as y } from "@partoohub/ui";
import { SelectButtonContainer as x } from "./SelectButton.styled.js";
import { ConditionalResetIcon as u } from "../../ConditionalResetIcon/ConditionalResetIcon.js";
const C = ({
  dataTrackId: a,
  buttonText: t,
  label: s,
  disabled: o = !1,
  readonly: f = !1,
  required: m = !1,
  onClick: n,
  onReset: c
}) => {
  const l = h(null);
  return g({
    ref: l,
    onEnter: () => {
      !o && n && n();
    }
  }), /* @__PURE__ */ e(x, { ref: l, "data-track": a, onClick: n, "aria-disabled": o, "aria-readonly": f, tabIndex: 0, children: /* @__PURE__ */ r(i, { direction: "row", gap: "16px", alignItems: "center", style: {
    height: "100%"
  }, justifyContent: "space-between", children: [
    /* @__PURE__ */ r(i, { direction: "column", justifyContent: "center", alignItems: "flex-start", gap: "6px", children: [
      s && /* @__PURE__ */ r(i, { direction: "row", gap: "4px", alignItems: "flex-start", justifyContent: "center", children: [
        /* @__PURE__ */ e(d, { variant: t ? "bodyXSSemibold" : "bodyMSemibold", color: "secondary", children: s }),
        m && /* @__PURE__ */ e(y, { icon: ["fa-asterisk"], color: "danger", iconSize: t ? "8px" : "10px" })
      ] }),
      t && /* @__PURE__ */ e(d, { variant: "bodyMRegular", children: t })
    ] }),
    /* @__PURE__ */ e(u, { dataTrackId: a, onReset: (p) => {
      p.stopPropagation(), o || c?.();
    }, showReset: !!c })
  ] }) });
};
export {
  C as SelectButton
};
